class TileCalculator extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.data = JSON.parse(this.querySelector('.tile-calculator-data').textContent);
    this.mPrPackage = this.data.landing_product.mPrPackage;
    this.variantPrice = this.data.landing_product.price;

    this.inputField = this.querySelector('.tile-calculator__input-field');
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.submitButton = this.querySelector('input[type="submit"]');

    this.totalPriceField = this.querySelector('[data-cal-total-price]');
    this.squareMeterResult = this.querySelector('.tile-calculator__result');

    this.boxesNeeded = 0;
    this.defaultInputQuantity = document.querySelector('[data-cal-amount]');
    this.defaultAddToCartButton = document.querySelector('[data-cal-add-to-cart]');

    this.inputField.addEventListener('input', this.calculateSquareMeters.bind(this));
    this.checkbox.addEventListener('change', this.calculateSquareMeters.bind(this));

    document.addEventListener('variantIdChange', (e) => {
      const curVariantId = e.detail.variantId;
      const matchingVariant = this.data.variants.find(variant => variant.id == curVariantId);
      this.mPrPackage = parseFloat(matchingVariant.square_meter_price);
      this.variantPrice = parseFloat(matchingVariant.price);
      this.calculateSquareMeters();
    });
  }

  setTotalPrice() {
    let totalPrice = this.boxesNeeded * this.variantPrice;
    if (totalPrice > 0) {
      this.totalPriceField.textContent = this.data.translations.total_price.replace('$totalPrice$', totalPrice);
    } else {
      this.totalPriceField.textContent = this.data.translations.no_result
    }
  }

  submitBoxesNeeded() {
    function handleClick(e) {
      e.preventDefault();
      this.defaultInputQuantity.value = this.boxesNeeded;
      setTimeout(() => {
        this.defaultAddToCartButton.click();
      }, 100);
    }

    if (this.defaultInputQuantity && this.defaultAddToCartButton) {
      this.submitButton.addEventListener('click', handleClick.bind(this));
    } else {
      this.submitButton.removeEventListener('click', handleClick.bind(this));
    }
  }

  calculateSquareMeters() {
    let inputValue = parseFloat(this.inputField.value);
    if (this.mPrPackage == "") return;

    if (isNaN(inputValue)) {
      this.squareMeterResult.textContent = this.data.translations.no_result;
      this.boxesNeeded = 0;
    } else {
      if (this.checkbox.checked) {
        console.log(this.data.waste.percentage)
        if (this.data.waste.percentage != ""){
          inputValue *= `1.${this.data.waste.percentage}`;
        } else {
          inputValue *= 1.12;
        }
      }
      this.boxesNeeded = Math.ceil(inputValue / this.mPrPackage);
      const totalSquareMeters = this.boxesNeeded * this.mPrPackage;

      this.squareMeterResult.textContent = this.data.translations.result.replace('$amount$', this.boxesNeeded).replace('$total$', totalSquareMeters.toFixed(2));
    }

    this.setTotalPrice();
    if (this.boxesNeeded > 0){
      this.submitBoxesNeeded();
    }
  }
}

customElements.define('tile-calculator', TileCalculator);
